'use client'

import { useEffect, useState } from 'react'
import styles from './Switch.module.scss'
import { clsx } from 'clsx'

export default function Switch({ onClick, value = false }: { onClick: (enabled: boolean) => void; value?: boolean }) {
  const [enabled, setEnabled] = useState(value)

  const handleToggle = () => {
    setEnabled((prev) => !prev)
  }

  useEffect(() => {
    onClick(enabled)
  }, [enabled])

  return (
    <button
      className={clsx(styles.switch, enabled && styles.active)}
      onClick={handleToggle}
      aria-pressed={enabled}
      data-cy="switch"
    >
      <span className={styles['switch-thumb']} />
    </button>
  )
}
